import { Tag } from '@sixfold/common-ui';
import React from 'react';

interface Props {
  tags: { name: string }[];
}

export const Tags: React.FunctionComponent<Props> = ({ tags }) => (
  <>
    {tags.map((tag) => (
      <Tag size="small" key={tag.name}>
        {tag.name}
      </Tag>
    ))}
  </>
);
